// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.referral-management-page .dashboard-body {
  padding-bottom: 2rem;
}

.referral-hero__icon {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: rgba(15, 118, 110, 0.4);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
}

.referral-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-bottom: 1rem;
}

.referral-stat-card {
  background: #fff;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 12px;
  padding: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.referral-stat-card__value {
  display: block;
  font-size: 1.5rem;
  font-weight: 700;
  color: #0f172a;
}

.referral-stat-card__label {
  font-size: 0.85rem;
  color: #64748b;
}

.referral-tabs {
  display: flex;
  gap: 0.75rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.referral-tab {
  border: 1px solid #dbe2ea;
  background: #fff;
  color: #334155;
  border-radius: 999px;
  padding: 0.45rem 0.85rem;
  font-size: 0.86rem;
  font-weight: 600;
  cursor: pointer;
}

.referral-tab--active {
  color: #fff;
  border-color: #0f766e;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
}

.referral-export-btn {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.45rem 0.9rem;
  font-size: 0.86rem;
  font-weight: 600;
  font-family: inherit;
  color: #fff;
  background: linear-gradient(135deg, #15803d 0%, #22c55e 100%);
  border: none;
  border-radius: 999px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.referral-export-btn:hover:not(:disabled) {
  opacity: 0.95;
}

.referral-export-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.referral-export-toast {
  margin: 0 0 1rem;
  padding: 0.55rem 0.85rem;
  border-radius: 8px;
  font-size: 0.875rem;
}

.referral-export-toast--success {
  color: #166534;
  background: rgba(22, 101, 52, 0.1);
}

.referral-export-toast--error {
  color: #b91c1c;
  background: rgba(220, 38, 38, 0.08);
}

.referral-section {
  background: #fff;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 12px;
  padding: 1rem;
  margin-bottom: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.referral-section__title {
  margin: 0 0 0.85rem;
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.referral-empty {
  text-align: center;
  color: #64748b;
  padding: 1.25rem 0.6rem;
}

.referral-empty i {
  display: block;
  font-size: 1.6rem;
  margin-bottom: 0.5rem;
}

.referral-table-wrap {
  overflow-x: auto;
}

.referral-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.referral-table th {
  padding: 0.75rem 0.8rem;
  text-align: left;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #f8fafc;
  background: #0f172a;
  white-space: nowrap;
}

.referral-table td {
  padding: 0.75rem 0.8rem;
  border-bottom: 1px solid #e2e8f0;
  color: #1e293b;
  vertical-align: top;
}

.referral-table tbody tr:nth-child(even) {
  background: #fafafa;
}

.referral-btn-view {
  border: none;
  border-radius: 6px;
  padding: 0.35rem 0.7rem;
  font-size: 0.78rem;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  cursor: pointer;
}

.referral-pagination {
  margin-top: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.referral-page-limit {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
}

.referral-page-limit select {
  min-width: 88px;
  padding: 0.4rem 0.6rem;
  font-size: 0.875rem;
  font-family: inherit;
  border: 1px solid #dbe2ea;
  border-radius: 8px;
  background: #fff;
  color: #0f172a;
  cursor: pointer;
}

.referral-page-limit select:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.referral-pagination__info {
  font-size: 0.85rem;
  color: #64748b;
}

.referral-pagination__nav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.referral-pagination button {
  border: 1px solid #dbe2ea;
  background: #fff;
  color: #0f172a;
  border-radius: 8px;
  padding: 0.35rem 0.65rem;
  cursor: pointer;
}

.referral-pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.referral-airdrop-meta {
  font-size: 0.82rem;
  color: #475569;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0.65rem 0.85rem;
  margin-bottom: 1rem;
  line-height: 1.5;
}

.referral-airdrop-meta strong {
  color: #0f172a;
}

.referral-airdrop-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  margin-bottom: 0.85rem;
}

.referral-airdrop-toolbar form {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
}

.referral-airdrop-search-input {
  min-width: 200px;
  border: 1px solid #dbe2ea;
  border-radius: 8px;
  padding: 0.45rem 0.65rem;
  font-size: 0.86rem;
}

.referral-airdrop-search-btn {
  border: none;
  border-radius: 8px;
  padding: 0.45rem 0.85rem;
  font-size: 0.82rem;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  cursor: pointer;
}

.referral-task-cells {
  display: inline-flex;
  gap: 0.2rem;
  flex-wrap: wrap;
}

.referral-task-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.65rem;
  padding: 0.15rem 0.35rem;
  border-radius: 6px;
  font-size: 0.72rem;
  font-weight: 700;
  font-family: ui-monospace, monospace;
}

.referral-task-pill--done {
  background: rgba(13, 148, 136, 0.15);
  color: #0f766e;
}

.referral-task-pill--todo {
  background: #f1f5f9;
  color: #94a3b8;
}

.referral-user-summary-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.6rem 1rem;
  margin-bottom: 1rem;
  font-size: 0.88rem;
}

.referral-subsection h3 {
  margin: 0 0 0.6rem;
  font-size: 0.92rem;
  color: #0f172a;
}

.referral-subsection + .referral-subsection {
  margin-top: 1rem;
}

.referral-muted {
  margin: 0.2rem 0;
  color: #64748b;
}

@media (max-width: 1024px) {
  .referral-stats {
    grid-template-columns: 1fr;
  }

  .referral-user-summary-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 768px) {
  .referral-user-summary-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/System/ReferralManagementPage.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,6DAA6D;EAC7D,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,6DAA6D;EAC7D,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".referral-management-page .dashboard-body {\n  padding-bottom: 2rem;\n}\n\n.referral-hero__icon {\n  flex-shrink: 0;\n  width: 52px;\n  height: 52px;\n  border-radius: 12px;\n  background: rgba(15, 118, 110, 0.4);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.3rem;\n}\n\n.referral-stats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.referral-stat-card {\n  background: #fff;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 12px;\n  padding: 1rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.referral-stat-card__value {\n  display: block;\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.referral-stat-card__label {\n  font-size: 0.85rem;\n  color: #64748b;\n}\n\n.referral-tabs {\n  display: flex;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n  flex-wrap: wrap;\n}\n\n.referral-tab {\n  border: 1px solid #dbe2ea;\n  background: #fff;\n  color: #334155;\n  border-radius: 999px;\n  padding: 0.45rem 0.85rem;\n  font-size: 0.86rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.referral-tab--active {\n  color: #fff;\n  border-color: #0f766e;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n}\n\n.referral-export-btn {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  padding: 0.45rem 0.9rem;\n  font-size: 0.86rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: #fff;\n  background: linear-gradient(135deg, #15803d 0%, #22c55e 100%);\n  border: none;\n  border-radius: 999px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.referral-export-btn:hover:not(:disabled) {\n  opacity: 0.95;\n}\n\n.referral-export-btn:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.referral-export-toast {\n  margin: 0 0 1rem;\n  padding: 0.55rem 0.85rem;\n  border-radius: 8px;\n  font-size: 0.875rem;\n}\n\n.referral-export-toast--success {\n  color: #166534;\n  background: rgba(22, 101, 52, 0.1);\n}\n\n.referral-export-toast--error {\n  color: #b91c1c;\n  background: rgba(220, 38, 38, 0.08);\n}\n\n.referral-section {\n  background: #fff;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 12px;\n  padding: 1rem;\n  margin-bottom: 1rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.referral-section__title {\n  margin: 0 0 0.85rem;\n  font-size: 1rem;\n  font-weight: 700;\n  color: #0f172a;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.referral-empty {\n  text-align: center;\n  color: #64748b;\n  padding: 1.25rem 0.6rem;\n}\n\n.referral-empty i {\n  display: block;\n  font-size: 1.6rem;\n  margin-bottom: 0.5rem;\n}\n\n.referral-table-wrap {\n  overflow-x: auto;\n}\n\n.referral-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.85rem;\n}\n\n.referral-table th {\n  padding: 0.75rem 0.8rem;\n  text-align: left;\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #f8fafc;\n  background: #0f172a;\n  white-space: nowrap;\n}\n\n.referral-table td {\n  padding: 0.75rem 0.8rem;\n  border-bottom: 1px solid #e2e8f0;\n  color: #1e293b;\n  vertical-align: top;\n}\n\n.referral-table tbody tr:nth-child(even) {\n  background: #fafafa;\n}\n\n.referral-btn-view {\n  border: none;\n  border-radius: 6px;\n  padding: 0.35rem 0.7rem;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: #fff;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  cursor: pointer;\n}\n\n.referral-pagination {\n  margin-top: 0.8rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.referral-page-limit {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #64748b;\n}\n\n.referral-page-limit select {\n  min-width: 88px;\n  padding: 0.4rem 0.6rem;\n  font-size: 0.875rem;\n  font-family: inherit;\n  border: 1px solid #dbe2ea;\n  border-radius: 8px;\n  background: #fff;\n  color: #0f172a;\n  cursor: pointer;\n}\n\n.referral-page-limit select:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.referral-pagination__info {\n  font-size: 0.85rem;\n  color: #64748b;\n}\n\n.referral-pagination__nav {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.referral-pagination button {\n  border: 1px solid #dbe2ea;\n  background: #fff;\n  color: #0f172a;\n  border-radius: 8px;\n  padding: 0.35rem 0.65rem;\n  cursor: pointer;\n}\n\n.referral-pagination button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.referral-airdrop-meta {\n  font-size: 0.82rem;\n  color: #475569;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 0.65rem 0.85rem;\n  margin-bottom: 1rem;\n  line-height: 1.5;\n}\n\n.referral-airdrop-meta strong {\n  color: #0f172a;\n}\n\n.referral-airdrop-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  align-items: center;\n  margin-bottom: 0.85rem;\n}\n\n.referral-airdrop-toolbar form {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.referral-airdrop-search-input {\n  min-width: 200px;\n  border: 1px solid #dbe2ea;\n  border-radius: 8px;\n  padding: 0.45rem 0.65rem;\n  font-size: 0.86rem;\n}\n\n.referral-airdrop-search-btn {\n  border: none;\n  border-radius: 8px;\n  padding: 0.45rem 0.85rem;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #fff;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  cursor: pointer;\n}\n\n.referral-task-cells {\n  display: inline-flex;\n  gap: 0.2rem;\n  flex-wrap: wrap;\n}\n\n.referral-task-pill {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.65rem;\n  padding: 0.15rem 0.35rem;\n  border-radius: 6px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  font-family: ui-monospace, monospace;\n}\n\n.referral-task-pill--done {\n  background: rgba(13, 148, 136, 0.15);\n  color: #0f766e;\n}\n\n.referral-task-pill--todo {\n  background: #f1f5f9;\n  color: #94a3b8;\n}\n\n.referral-user-summary-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.6rem 1rem;\n  margin-bottom: 1rem;\n  font-size: 0.88rem;\n}\n\n.referral-subsection h3 {\n  margin: 0 0 0.6rem;\n  font-size: 0.92rem;\n  color: #0f172a;\n}\n\n.referral-subsection + .referral-subsection {\n  margin-top: 1rem;\n}\n\n.referral-muted {\n  margin: 0.2rem 0;\n  color: #64748b;\n}\n\n@media (max-width: 1024px) {\n  .referral-stats {\n    grid-template-columns: 1fr;\n  }\n\n  .referral-user-summary-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .referral-user-summary-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
